import { AccessControlProvider } from '@refinedev/core';
import { TPermission } from 'interfaces/permissions';
import { isClassroomForumEnabled } from 'services/tenants';

const ALL = '*';

/**
 * Recursos que existem só quando o tenant contratou fórum de turma. Negar aqui
 * cobre rota, aba e botões de uma vez — é o que o refine já consulta em todo
 * useCan/CanAccess.
 */
const CLASSROOM_FORUM_RESOURCES = new Set(['professor_area/forums']);

const accessProvider: AccessControlProvider = {
  can: async ({ resource: givenResource, action: givenAction }) => {
    if (
      givenResource &&
      CLASSROOM_FORUM_RESOURCES.has(givenResource) &&
      !isClassroomForumEnabled()
    ) {
      return { can: false };
    }

    let permissions;
    const storagePermissions = localStorage.getItem('auth-permissions');

    if (storagePermissions) {
      permissions = JSON.parse(storagePermissions);
    }

    if (!permissions) {
      return { can: false };
    }

    const can = permissions.some((permission: TPermission) =>
      [givenResource, ALL].some(resource =>
        [givenAction, ALL].some(
          action =>
            [resource, action].join(':') === permission ||
            [resource, action, ALL].join(':') === permission
        )
      )
    );

    return { can };
  }
};

export default accessProvider;
